export default __webpack_public_path__ + "static/0256-84db0f10ce4031512d06fd036ad9afc8.png";